




















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import DSelectbox from "@/components/DSelectbox/selectbox.vue";
import DxTextBox from 'devextreme-vue/text-box';
import DxSelectBox from 'devextreme-vue/select-box';
import DButton from "@/components/DButton/button.vue";
import TableGrid from '@/components/TableGrid/grid.vue';
import TreeDropDownBox from "@/components/TreeDropDownBox/tree-drop-down-box.vue";
import { biling_methods } from "@/constants";
import ContractorService from "@/services/contractor-service";
import CutService from "@/services/cut-service"
import {
  Contractor,
  YearType,
  CutType,
  EcoObjectType,
  FilialNodeTreeExtended,
  FilialExtended,
  EcoFilialSelectionType,
  EcoNodeSelectionType,
} from "@/services/models-service";
import YearService from "@/services/years-service";
import { confirm } from "devextreme/ui/dialog";
import * as _ from "lodash";
import AuthService from "@/services/auth_service";
import EcoObjectsService  from "@/services/eco-objects-service";
import UserAccessService from '@/services/user_access_service';
import getGridInstance from "@/utils/grid-instance";
import TreeDropDownBoxSingleCheck from "@/components/TreeDropDownBox/tree-drop-down-box-single-check.vue";

interface EcoFacilitySelectionType {
  id: number;
  name: string;
  check: boolean;
}

@Component({
  name: "Contractor",
  components: {
    TreeDropDownBoxSingleCheck,
    DButton,
    DSelectbox,
    DxSelectBox,
    TableGrid,
    DxTextBox,
    TreeDropDownBox
  }
})
export default class extends Vue {
  public auth_service = AuthService;
  public userAccessService = UserAccessService;
  public hasEditData = false;
  public hint = 'Контрагент используется, нельзя редактировать';

  public current_year: any = '';
  public current_cut: any = '';
  public current_filial: number | null = null;
  public current_node: number | null = null;
  public columns: Array<any> = [];
  public all_years: YearType [] = [];
  public all_filials: EcoObjectType [] = [];
  public all_filials_tree: any = [];
  public all_nodes: EcoObjectType [] = [];
  public facilities: EcoObjectType [] = [];
  public filtered_facilities: any[] = [];
  public cuts: CutType[] = [];
  public filter: any[] = [];
  public contractor_service = ContractorService;
  public methods = biling_methods;
  public isLoad: boolean = false;
  public searchQuery: string = '';

  public permission_nodes: any[] = [];
  public disableSelector: boolean = false;

  public allowEditContractor: boolean = false;

  private ls_key: string = 'contragents_filter';
  private saved_filters: any = {
    year_id: null,
    cut_id: null,
    filial_id: null,
    heat_node_id: null,
  }

  public show_pao_tplus = false;
  public oneActiveCheck = true;
  public showFacility = false;
  public checkAllFilials: boolean = false;
  public selectionData: EcoFilialSelectionType[] = [];

  onHierarchyChanged({ filials, nodes, facilities }: {
    filials: number[];
    nodes: number[];
    facilities: number[];
  }) {
    if (!this.isLoad && (!nodes || nodes.length === 0)) {
      return;
    }
    const val = nodes[0] ?? null;
    if (val === this.current_node) {
      this.current_node = null;
      this.$nextTick(() => { this.current_node = val; }); // два изменения подряд → watcher сработает
    } else {
      this.current_node = val;
    }
    if (this.isLoad) {
      this.saveFilters();
    }
  }

  async getFilialsNodesTree() {
    // Проверяем, что выбраны год и срез
    if (!this.current_year || !this.current_cut) {
      return;
    }

    // Находим объекты года и среза
    const year = this.all_years.find((y: YearType) => y.id === this.current_year);
    const cut  = this.cuts.find((c: CutType)   => c.id === this.current_cut);
    if (!year || !cut) {
      return;
    }

    // Формируем множество разрешённых филиалов для текущего пользователя
    const allowedFilials = new Set<number>();
    for (const key in UserAccessService.userAccessDS) {
      allowedFilials.add(+key);
    }

    // Узнаём текущий маршрут и список доступных узлов
    const route = this.$route.name;
    this.permission_nodes = route
      ? UserAccessService.checkReading(route)
      : [];

    // Запрашиваем расширённое дерево филиалов
    const response = await EcoObjectsService.filial_nodes_tree_extended(cut.id_eco_version, year.name, null);

    if (!response.data) {
      this.selectionData = [];
      return;
    }

    // Клонируем, чтобы не мутировать оригинал
    const tree = _.cloneDeep(response.data);

    // Собираем структуру selectionData
    const selectionData: EcoFilialSelectionType[] = [];

    for (const filialKey in tree) {
      const filialEntry = tree[Number(filialKey)];
      const filialId    = filialEntry.filial.id;

      // Пропускаем, если нет доступа к филиалу (и пользователь не админ)
      if (!this.auth_service.isAdmin() && !allowedFilials.has(filialId)) {
        continue;
      }

      // Собираем массив узлов с пустым полем facilities
      const nodes: EcoNodeSelectionType[] = [];

      for (const nodeKey in filialEntry.nodes) {
        const node = filialEntry.nodes[Number(nodeKey)];

        // Фильтруем по правам чтения
        if (this.permission_nodes.indexOf(node.id) === -1) {
          continue;
        }

        // Иначе — просто пустой массив
        const facilities: EcoFacilitySelectionType[] = [];

        const check = node.id === this.saved_filters.heat_node_id;

        nodes.push({
          id:         node.id,
          name:       node.name,
          check:      check,
          facilities: facilities
        });
      }

      // Добавляем только если есть хотя бы один доступный узел
      if (nodes.length) {
        selectionData.push({
          id:    filialId,
          name:  filialEntry.filial.name,
          check: false,
          nodes: nodes
        });
      }
    }

    // Сохраняем и даём компоненту нужную форму данных
    this.selectionData = selectionData;
  }

  async created() {

    this.isLoad = false;

    this.loadFilters();

    this.all_years = YearService.filteredYearList;
    if (this.saved_filters.year_id) {
      this.current_year = this.saved_filters.year_id;
    } else {
      this.current_year = YearService.current?.id;
    }

    await this.getCutsYear();

    if (this.saved_filters.cut_id) {
      this.current_cut = this.saved_filters.cut_id;
    }

    await this.getFilialsNodesTree();
    await this.getFilialsTree();

    if (!_.isNil(this.saved_filters.filial_id)) {
      this.current_filial = this.saved_filters.filial_id;

      this.all_nodes = this.all_filials_tree[`${this.current_filial}`];

      if (this.saved_filters.heat_node_id) {
        this.current_node = this.saved_filters.heat_node_id;
      }
    }


    const current = this.permission_nodes.find((node: number) => node === this.saved_filters.heat_node_id);
    if(!current) {
      // this.current_node = null;
      // this.saved_filters.heat_node_id = null;
    }

    await this.getFacility();
    this.initColumns();

    if (this.current_cut && this.current_node) {
      this.filter = [
        ["id_cut", "=", this.current_cut],
        ["id_eco_heat_node", "=", this.saved_filters.heat_node_id]
      ];

      this.allowEditContractor = UserAccessService.checkEditingContractor(this.current_node);
    }

    setTimeout(() => {
      this.isLoad = true;
    }, 500)
  }

  async mounted() {}

  destroyed() {}

  private initColumns() {
    localStorage.removeItem('contAgGrid')
    this.columns = [
      {
        dataField: "name",
        dataType: "string",
        caption: "Контрагент",
        validationRules: [{ type: 'required' }],
        width: "20%"
      },
      {
        dataField: "model_name_eco",
        dataType: "string",
        caption: "Модельное название",
        width: "10%",
        allowSorting: true,
        calculateSortValue: "model_name_eco",
        lookup: {
          dataSource: this.getStore,
          valueExpr: 'id',
          displayExpr: "name"
        },
        editorOptions: {
        showClearButton: true,
        },
        setCellValue: this.changeInternalTurnover,
        calculateDisplayValue: (rowData : any) => {
    if (!rowData.model_name_eco) return '';
    const facility = this.facilities.find(f => f.id == rowData.model_name_eco);
    return facility ? `${facility.name}` : '';
  },
      },
      {
        dataField: `internal_turnover`,
        dataType: "boolean",
        caption: "Внутренний оборот (изменяется автоматически)",
        width: "10%",
      },
      {
        dataField: "vgo_fb",
        dataType: "boolean",
        caption: "ВГО ФБ01-07",
        width: "10%"
      },
      {
        dataField: "reg_kind_activity",
        dataType: "boolean",
        caption: "Регулируемый вид деятельности",
        width: "10%"
      },
      {
        dataField: "purchase",
        dataType: "boolean",
        caption: "Покупка",
        width: "10%",
        allowEditing: (rowData: Contractor) => rowData.purchase_disable !== true,
      },
      {
        dataField: "realization",
        dataType: "boolean",
        caption: "Реализация",
        width: "10%",
        allowEditing: (rowData: Contractor) => rowData.realization_disable !== true,
      },
      {
        dataField: "transport_expenses",
        dataType: "boolean",
        caption: "Транспорт, затраты",
        width: "10%",
        allowEditing: (rowData: Contractor) => rowData.transport_expenses_disable !== true,
      },
      {
        dataField: "transport_revenue",
        dataType: "boolean",
        caption: "Транспорт, выручка",
        width: "10%",
        allowEditing: (rowData: Contractor) => rowData.transport_revenue_disable !== true,
      },
      {
        dataField: "article_fb02",
        dataType: "string",
        caption: "статья ФБ-02",
        width: "10%",
        allowEditing: (rowData: Contractor) => rowData.transport_revenue_disable !== true,
      },
      {
        dataField: "client_code",
        caption: "Код клиента",
        dataType: "string",
        width: "10%"
      },
      {
        dataField: "instance_id",
        caption: "ID",
        width:'10%'
      },
      {
        dataField: "id_cut",
        visible: false,
      },
      {
        dataField: "id_eco_heat_node",
        visible: false,
      }
    ];
  }

  getStore() {
    return { store: this.facilities }
  }

  changeInternalTurnover(newData:any, value:any, currentRowData: any) {
    newData.model_name_eco = value;
    if (value) {
      newData.internal_turnover = true;
    } else {
      newData.internal_turnover = false;
    }
  }

  async getFilialsTree() {

    if (!this.current_year || !this.current_cut) {
      return
    }

    const year = this.all_years.find((y: YearType) => y.id === this.current_year);
    const cut = this.cuts.find((c: CutType) => c.id === this.current_cut);

    if (!year || !cut) {
      return
    }
    let allowed_filials_ids = new Set();
    for (let key in UserAccessService.userAccessDS) {
      allowed_filials_ids.add(+key)
    }

    let route = this.$route.name
    if (route) {
      this.permission_nodes = UserAccessService.checkReading(route);
    }

    this.all_filials = [];
    this.all_filials_tree = {};
    const response = await EcoObjectsService.filial_nodes_tree_extended(cut.id_eco_version, year.name, null);
    if (response.data) {

      const filials_tree: FilialNodeTreeExtended = _.cloneDeep(response.data);

      for (let filial_uid in filials_tree) {
        const filial: FilialExtended = filials_tree[Number(filial_uid)];
        const filial_id: string = `${filial.filial.id}`;
        if (!this.auth_service.isAdmin() && !allowed_filials_ids.has(filial.filial.id)) {
          continue
        }

        this.all_filials_tree[filial_id] = [];

        for (let node_uid in filial.nodes) {
          const node = filial.nodes[Number(node_uid)];
          if (this.permission_nodes.indexOf(node.id) !== -1) {
            this.all_filials_tree[filial_id].push(node)
          }
        }

        if (this.all_filials_tree[filial_id].length > 0) {
          this.all_filials.push(filial.filial);
        }

      }
    }

  }

  async getFacility() {
    const year = this.all_years.find((y:YearType) => y.id === this.current_year);
    const cut = this.cuts.find((c:CutType) => c.id === this.current_cut);
    if(year?.name && cut?.id_eco_version && this.current_node) {
        const months: any = [];
        const response = await EcoObjectsService.get_facilities(cut.id_eco_version, this.current_node, null, year.name, months);
        if (response?.data) {
            this.facilities = response?.data;
        }
    }
  }


  async getCutsYear() {
    const response = await CutService.getWithFilter(this.current_year);
    if (response.data) {
      const cuts_resp = _.sortBy(response.data, [(o) => o.number]);

      this.cuts =  cuts_resp.filter((c) => c.visible_for === 'Видимый для администратора' || c.visible_for === 'Видимый для всех');
    }
  }

  onSaving(e:any) {
    for (let change of e.changes) {
      if (change.data && !change.data.id_cut) {
        change.data.id_cut = this.current_cut;
      }
      if (change.data && !change.data.id_eco_heat_node) {
        change.data.id_eco_heat_node = this.current_node;
      }
    }
  }


  initNewRow(e:any) {
    e.data.heat_biling_method = "УУТЭ";
    e.data.gvo_biling_method = "УУТЭ";
    e.data.internal_turnover = false;
    e.data.vgo_fb = false;
    e.data.reg_kind_activity = true;
    e.data.purchase = false;
    e.data.realization = false;
    e.data.transport_expenses = false;
    e.data.transport_revenue = false;
  }

  onOpened() {
    this.hasEditDate();
  }

  empty() {
    //
  }


  @Watch("current_year")
  async changeYear() {
    if (!this.isLoad) {
      return;
    }

    this.current_cut= '';
    await this.getCutsYear();

    this.saveFilters();
  }

  @Watch("current_filial")
  async changeFilial() {
    if (!this.isLoad) {
      return;
    }

    this.current_node= null;
    this.saveFilters();

    this.all_nodes = [];
    if (this.current_filial) {
      this.all_nodes = this.all_filials_tree[`${this.current_filial}`]
    }

  }

  @Watch("current_cut")
  async changeCut() {
    if (!this.isLoad) return;
    const prevFilial: number | null = this.current_filial;
    const prevNode: number | null = this.current_node;
    if (this.current_cut) {
      await this.getFilialsTree();
      await this.getFilialsNodesTree();
      if (this.all_filials.some((f: EcoObjectType) => f.id === prevFilial)) {
        this.current_filial = prevFilial;
        if (this.all_filials_tree[`${prevFilial}`]?.some((n: EcoObjectType) => n.id === prevNode)) {
          this.current_node = prevNode;
        } else {
          this.current_node = null;
        }
      } else {
        this.current_filial = null;
        this.current_node = null;
      }
    } else {
      this.current_filial = null;
      this.current_node = null;
    }
    this.saveFilters();
  }

  onSearch() {
    this.debouncedSearch();
  }

  private debouncedSearch = _.debounce(() => {
    this.applySearchFilter();
  }, 300); 
  

  onResetSearch() {
    this.searchQuery = '';
    this.applySearchFilter();
  }

  applySearchFilter() {
    const baseFilter = [
      ["id_cut", "=", this.current_cut],
      ["id_eco_heat_node", "=", this.current_node],
    ];

    const trimmedQuery = this.searchQuery.trim();

    if (trimmedQuery.length === 0) {
      this.filter = baseFilter;
      return;
    }

    if (trimmedQuery.length >= 3) {
      this.filter = baseFilter.concat([
        "and",
        [
          "or",
          ["name", "contains", trimmedQuery],
          ["model_name_eco", "contains", trimmedQuery]
        ]
      ]);
    }
  }

  @Watch("current_node")
  async changeNodes() {
    if (!this.isLoad) {
      return;
    }

    if (this.current_cut && this.current_node) {
      this.applySearchFilter();

      this.allowEditContractor = UserAccessService.checkEditingContractor(this.current_node);
      await this.getFacility();
      this.initColumns();
    }

    this.saveFilters();
  }

  hasEditDate() {
    if(this.isLoad && this.current_node && this.current_cut) {
      const grid: any = getGridInstance(this.$refs.grid);
      let isEdit  = grid.hasEditData();
      if (isEdit) {
        confirm('Имеются несохранённые изменения. Сохранить?', 'Сохранение')
        .then((answer: boolean) => {
          if (answer) {
            grid.saveEditData();
          } else {
            grid.cancelEditData();

          }
        });
      }
    }
  }

  onAddNewContragent() {
    const grid = getGridInstance(this.$refs.grid);
    if (grid) {
      grid.addRow();
    }
  }

  onSaveButtonTrigger() {
    const grid = getGridInstance(this.$refs.grid);
    const rows = grid.getVisibleRows();
    let haveIsRemoved = false;
    for (let row of rows) {
      if (row.removed === true) {
        haveIsRemoved = true;
        break;
      }
    }
    if (haveIsRemoved) {
      confirm('Удаление контрагента приведет к удалению связанных с ним данных на вкладках для заполнения. Удалить?', 'Удаление контрагента')
        .then((answer: boolean) => {
          if (answer) {
            grid.saveEditData();
          } else {
            return;

          }
        });
    } else {
      grid.saveEditData();
    }
  }

  onEditCancel() {
    const grid = getGridInstance(this.$refs.grid);
    if (grid) {
      grid.cancelEditData();
    }
  }

  onCellPrepared(e: any) {
    if(e.rowType === "data") {
      // @ts-ignore
      const toolTip =  this.$refs.grid.$refs.tooltipRef.instance;
      const fields = ["reg_kind_activity", "internal_turnover", "model_name_eco"]

      if ((e.data[`${e.column.dataField}_disable`])) {
        e.cellElement.addEventListener('mouseover', (arg: any) => {
          toolTip.show(arg.target);
        });
        e.cellElement.addEventListener('mouseout', () => {
          toolTip.hide();
        });
      } else if(fields.includes(e.column.dataField)) {
        for(let key in e.data) {
          if(key.endsWith('_disable') && e.data[key]) {
            e.cellElement.addEventListener('mouseover', (arg: any) => {
              toolTip.show(arg.target);
            });
            e.cellElement.addEventListener('mouseout', () => {
              toolTip.hide();
            });
            break
          }
        }
      }
    }
    if (
      e.rowType === 'header' &&
      !e.cellElement.querySelector('.dx-datagrid-text-content') &&
      e.column.caption
    ) {
      const div = document.createElement('div');
      div.className = 'dx-datagrid-text-content';
      div.textContent = e.column.caption;
      e.cellElement.innerHTML = '';
      e.cellElement.appendChild(div);
    }
  }

  onEditorPreparing(e:any) {
    const fields = ["reg_kind_activity", "model_name_eco"]
    if(e.parentType == "dataRow" && e.row.data[`${e.dataField}_disable`]) {
      e.editorOptions.disabled = !e.row.inserted;
    }
    if(e.dataField == "internal_turnover" && e.parentType == "dataRow"){
      e.editorOptions.disabled = !e.row.inserted;
    }
    if(e.parentType == "dataRow" && fields.includes(e.dataField)) {
      for(let key in e.row.data) {
        if(key.endsWith('_disable') && e.row.data[key]) {
          e.editorOptions.disabled = !e.row.inserted;
          break
        }
      }
    }
    if (e.parentType == 'dataRow' && e.dataField == 'model_name_eco') {
      e.editorOptions.itemTemplate = function(itemData:any, itemIndex:any, itemElement:any) {
        let itemEl: HTMLElement = document.createElement("div");
        itemEl.innerText = itemData.name;
        itemEl.setAttribute('title', itemData.name);
        itemEl.classList.add("lookup-item");
        itemElement.appendChild(itemEl);
      }
      e.editorOptions.dataSource = {
        store: {
          type: "array",
          data: this.facilities
        },
        // Переопредляет DataSource, disable items
        postProcess: function(data:any) {
          const rows = e.component.getVisibleRows();
          if (!rows) return;
          let newData = data.map((x:any) => {
            for (let row of rows) {
              if (row.data.model_name_eco && row.data.model_name_eco === x.id) {
                x.disabled = true;
                break;
              } else {
                x.disabled = false;
              }
            }
            return x;
          });

          return newData;
        }
      }
    }
  }

  checkTableIsEdit(e: any) {
    this.hasEditData = e.component.hasEditData();
  }

  saveFilters() {
    this.saved_filters.year_id = this.current_year;
    this.saved_filters.cut_id = this.current_cut;
    this.saved_filters.filial_id = this.current_filial;
    this.saved_filters.heat_node_id = this.current_node;

    localStorage.setItem(`${this.auth_service.getUserId()}_${this.ls_key}`, JSON.stringify(this.saved_filters));
  }

  loadFilters() {
    const saved = localStorage.getItem(`${this.auth_service.getUserId()}_${this.ls_key}`);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        this.saved_filters = _.clone(parsed);

      } catch (e) {
        //
      }
    }
  }

}
